import { TCreateConverter } from "data/types/Converter.types";
import { TEnableReportAccessDB, TEnableReportAccessUI, THubspotIntegrationDB, THubspotIntegrationUI } from "data/types/User";
import { yesNoOptionConverter } from "./General.converters";

export const enableReportAccessConverter: TCreateConverter<TEnableReportAccessUI, TEnableReportAccessDB> ={
  toDb: (data) => ({
    propertyManagementId: data.propertyManagementId,
    hasAccessToReports: data.hasAccessToReports,
  }),
};

export const hubspotEnableConverter: TCreateConverter<THubspotIntegrationUI, THubspotIntegrationDB> = {
  toDb: (data) => {
    return {
      propertyManagerId: data.propertyManagerId,
      needToPushToHubSpot: yesNoOptionConverter.toDb(data.needToPushToHubSpot) as boolean,
    };
  },
};